import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRouter } from "@tanstack/react-router";
import { AlertCircle, ArrowLeft, Home } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background text-foreground">
      <Card className="w-full max-w-md shadow-sm border-border">
        <CardContent className="p-6 space-y-6">
          {/* 404 Icon */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="text-6xl font-bold text-muted/30">404</div>
              <AlertCircle className="absolute top-1/2 start-1/2 transform -translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 w-8 h-8 text-muted-foreground/60" />
            </div>
          </div>

          {/* Content */}
          <div className="space-y-3 text-center">
            <h1 className="text-xl font-semibold text-foreground">{t("errors.notFound.title")}</h1>
            <p className="text-sm text-muted-foreground">{t("errors.notFound.description")}</p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button variant="outline" onClick={() => router.history.back()} className="gap-2">
              <ArrowLeft className="w-4 h-4 rtl:rotate-180" />
              {t("errors.notFound.goBack")}
            </Button>
            <Button onClick={() => router.navigate({ to: "/" })} className="gap-2">
              <Home className="w-4 h-4" />
              {t("errors.notFound.goHome")}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
